import Vue from 'vue';
import Vuex from 'vuex'
import axios from 'axios'
import VueAxios from 'vue-axios'

Vue.use(Vuex);
Vue.use(VueAxios, axios)

// eslint-disable-next-line no-unused-vars
import baseStore from "@shared/stores/baseStore";
// eslint-disable-next-line no-unused-vars
import {computeStepsAndNames} from "@shared/helpers/mappings"

import {KEYS} from "@shared/helpers/mappings"

/*

STORE SPECIFICO PER LA APP

 */


const appStore = new Vuex.Store({
    state: {

        chord_root: null, chord_tones: null, scale_root: null, scale_tones: null
    },

    getters: {

        chord_data(state) {

            if (state.chord_root === null || state.chord_tones === null) {
                return null;
            }
            return computeStepsAndNames(state.chord_root, state.chord_tones);
        },

        scale_data(state) {
            if (state.scale_root === null || state.scale_tones === null) {
                return null;
            }
            return computeStepsAndNames(state.scale_root, state.scale_tones);
        }
    },

    mutations: {

        // eslint-disable-next-line no-unused-vars
        initialiseStore(state) {
            baseStore.state.guitar.addLayer();
        },

        setChordAndScale(state, params) {

            baseStore.state.guitar.hideAllFrets();
            baseStore.state.guitar.hideAllFrets(0);

            state.chord_root = params.chord_root;
            state.chord_tones = params.chord_tones;

            state.scale_root = params.scale_root;
            state.scale_tones = params.scale_tones;

            let chord_root_step = KEYS[state.chord_root].step;
            let scale_root_step = KEYS[state.scale_root].step;

            if (params.chord_tones !== null && params.chord_tones !== undefined) {

                let chord_tones_and_notes = {};
                let chord_data = computeStepsAndNames(state.chord_root, state.chord_tones);

                for (let i = 0; i < chord_data.length; i++) {
                    chord_tones_and_notes[chord_data[i].step] = chord_data[i];
                }

                baseStore.state.guitar.setRootStep(chord_root_step);
                baseStore.state.guitar.showSelectedTones(state, params.chord_tones);
                baseStore.state.guitar.setTonesAndNotesFromStep(chord_tones_and_notes);
            }

            if (params.scale_tones !== null && params.scale_tones !== undefined) {

                let scale_tones_and_notes = [];
                let scale_data = computeStepsAndNames(state.scale_root, state.scale_tones);
                for (let i = 0; i < scale_data.length; i++) {
                    scale_tones_and_notes[scale_data[i].step] = scale_data[i]
                }

                baseStore.state.guitar.setRootStep(scale_root_step, 0);
                baseStore.state.guitar.showSelectedTones(state, params.scale_tones, 0);
                baseStore.state.guitar.setTonesAndNotesFromStep(scale_tones_and_notes, 0);
            }
        },
    }

})


export default appStore;
